export default __webpack_public_path__ + "static/overwhelmed-shopper-1ad89a48244630fbd06bb6e322d06acc.jpg";